import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getPenyelenggara = 'penyelenggara-pelatihan';
const getPenyelenggaraAll = 'penyelenggara-pelatihan';
const postPenyelenggaraUrl = 'penyelenggara-pelatihan';
const putPenyelenggara = 'penyelenggara-pelatihan/';
const deletePenyelenggara = 'penyelenggara-pelatihan/';
const getTipePengelola = 'tipe-pengelola';

class PenyelenggaraService {
    getPenyelenggara(currentPage, pageSize, filter) {
        return axios.get(
            API_URL + getPenyelenggara + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter,
            {
                headers: authHeader()
            });
    }
     getPenyelenggaraAll() {
         return axios.get(
            API_URL + getPenyelenggara + '?pageNo=0&pageSize=10000000&filter=&status=aktif',
            {
                 headers: authHeader()
            });
     }

    getTipePengelola() {
        return axios.get(
            API_URL + getTipePengelola,
            {
                headers: authHeader()
            });
    }

    postPenyelenggara(formData) {        
        return axios
        .post(
            API_URL + postPenyelenggaraUrl,
            formData,
            { headers: authHeader() }
        );
    }

    putPenyelenggara(formData) {
        var headers = authHeader(); 

        return axios
        .put(
            API_URL + putPenyelenggara + formData.idPenyelenggara, formData,
            { headers: authHeader() }
        );
    }

    deletePenyelenggara(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deletePenyelenggara + formData.id_penyelenggara,
                { headers: authHeader() }
            );
    }

}

export default new PenyelenggaraService();